(function () {
  /*********************************************************
   * CONFIG
   *********************************************************/
  const TARGET_PRODUCT_HANDLE = 'customize-your-flavor-mix';

  const SELECTORS = {
    supplyRadio: 'kaching-bundle .kaching-bundles__bar input[type="radio"]',
    selectedFlavor: '.kaching-bundles__collection-product__remove-button',
    addToCart: 'form[action="/cart/add"] button[type="submit"]'
  };

  // Supply → required flavor count
  const SUPPLY_REQUIREMENTS = {
    '1': 3,
    '2': 6,
    '3': 9
  };

  /*********************************************************
   * GUARDS
   *********************************************************/
  if (!window.location.pathname.includes(`/products/${TARGET_PRODUCT_HANDLE}`)) {
    return;
  }

  let selectedSupplyRadio = null;
  let observerInitialized = false;

  /*********************************************************
   * HELPERS
   *********************************************************/
  function getAddToCartButton() {
    return document.querySelector(SELECTORS.addToCart);
  }

  function disableAddToCart() {
    const btn = getAddToCartButton();
    if (!btn) return;
    btn.disabled = true;
    btn.classList.add('disabled');
  }

  function enableAddToCart() {
    const btn = getAddToCartButton();
    if (!btn) return;
    btn.disabled = false;
    btn.classList.remove('disabled');
  }

  function getSelectedSupplyValue() {
    if (!selectedSupplyRadio) return null;
  
    const supplyContainer = selectedSupplyRadio.closest('.kaching-bundles__bar');
    if (!supplyContainer) return null;
  
    const allSupplyContainers = Array.from(
      supplyContainer.parentElement.children
    ).filter(el => el.classList.contains('kaching-bundles__bar'));
  
    const index = allSupplyContainers.indexOf(supplyContainer);
  
    // index: 0 → 1 month, 1 → 2 month, 2 → 3 month
    return index !== -1 ? String(index + 1) : null;
  }

  /**
   * IMPORTANT:
   * Flavor count is calculated ONLY inside the selected supply option
   */
  function getSelectedFlavorCount() {
    if (!selectedSupplyRadio) return 0;

    const supplyContainer = selectedSupplyRadio.closest('.kaching-bundles__bar');
    
    if (!supplyContainer) return 0;
    return supplyContainer.querySelectorAll(SELECTORS.selectedFlavor).length;
  }

  function validateSelections() {
    disableAddToCart();

    const supplyValue = getSelectedSupplyValue();
    if (!supplyValue) return;

    const requiredCount = SUPPLY_REQUIREMENTS[supplyValue];
    if (!requiredCount) return;

    const selectedCount = getSelectedFlavorCount();
    if (selectedCount === requiredCount) {
      enableAddToCart();
    }
  }

  /*********************************************************
   * BINDINGS
   *********************************************************/
  function bindSupplyRadios() {
    const radios = document.querySelectorAll(SELECTORS.supplyRadio);
    if (!radios.length) return false;

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        selectedSupplyRadio = radio;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            validateSelections();
          });
        });
      });

      // Set default if pre-checked
      if (radio.checked) {
        selectedSupplyRadio = radio;
      }
    });

    validateSelections();
    return true;
  }

  function bindFlavorActions() {
    document.addEventListener('click', (e) => {
      const isFlavorAction =
        e.target.closest('.kaching-bundles__choose-product__product-button') ||
        e.target.closest('.kaching-bundles__collection-product__remove-button');

      if (!isFlavorAction) return;

      // Wait for DOM update from app
      setTimeout(validateSelections, 300);
    });
  }

  /*********************************************************
   * OBSERVER — WAIT FOR APP WIDGET TO LOAD
   *********************************************************/
  function initObserver() {
    if (observerInitialized) return;
    observerInitialized = true;

    const observer = new MutationObserver(() => {
      const radiosReady = bindSupplyRadios();
      if (radiosReady) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /*********************************************************
   * INIT
   *********************************************************/
  function init() {
    disableAddToCart();
    bindFlavorActions();

    // Try immediately
    const radiosReady = bindSupplyRadios();

    // If radios not ready, wait for widget load
    if (!radiosReady) {
      initObserver();
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
